export function getTranslatePath(translationKey: string): (dataKey: string) => string {
  return (dataKey: string) => `${translationKey}.${dataKey}`;
}
